import { render, staticRenderFns } from "./TaskGrid.vue?vue&type=template&id=97784c4e"
import script from "./TaskGrid.vue?vue&type=script&lang=js"
export * from "./TaskGrid.vue?vue&type=script&lang=js"
import style0 from "./TaskGrid.vue?vue&type=style&index=0&id=97784c4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports